module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAXUlEQVQ4jWOgFmDEZ87/PJv5DAwMCVDuAsZJRxJxqUUx6H+ezXsGBgYBIh35gXHSEUEYh4lqfqMWwBpG//Ns/uMzn3HSEQx9VPPaqEGjBg0Jgxbg0YNPjkLAwMAAALe8D1z0XLL/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_btn_delete.png
// module id = 729
// module chunks = 0